export const TYPE = `webdav`

export type WebdavBackedType = "webdav" | "server"
